import React from 'react';
import * as types from '../../actions/actionTypes';
import InternalLink from '../InternalLink';
import Link from '../Link';
import ContentWrapper from '../styles/ContentWrapper';

const ColoringOptions = () => {

    return (
        <article about="/faq/recoloring" typeof="schema:WebPage">
            <ContentWrapper>
                <h3>Wie ändere ich die Farben meines Designerstücks</h3>
                <p>Ja, richtig gelesen. Bei www.schnoffle.de kannst Du Dein
                    Designerstück in Deinen Farben umsetzen. Du kannst also den
                    Stoff für Deinen Lieblingsschnitt in einem Farbton färben
                    oder einzelne und sogar alle Farben spezifisch festlegen.
                    Jetzt ist es problemlos möglich, Deinen eigenen Stoff in den
                    für Dich passenden Farben zu bekommen.
                </p>

                <h3>Aber: Traue niemals Deinem
                    Bildschirm!</h3>

                <p>Auf Smartphone, Tablet , PC usw.
                    sehen die Farben oft anders aus.
                    Wenn Du es genau brauchst, musst
                    Du mit einer <InternalLink
                        to={{type: types.NAVIGATED_TO_COLORSWATCHES_CART_FORM}}
                        target="_blank"> gedruckten
                        Farbkarte</InternalLink> arbeiten. Wenn
                    es Dir annähernd reicht, leg los
                    und mach Dir keinen Kopf.</p>

                <p>Du hast verschiedene
                    Möglichkeiten für die Änderung
                    der Farbe.</p>

                <h3>1) Einzelne Farben ersetzen</h3>

                <p>Ein Klick auf das entsprechende
                    Farbfeld eröffnet Dir eine
                    riesige Auswahl an
                    Farbmöglichkeiten. Ändere
                    einfach das Blau in Rot und
                    fertig ist das
                    Stoffschwesterchen:</p>

                <img
                    src="//d2k02hhj0n6fcf.cloudfront.net/images/colorchange.png"
                    alt=""/>

                <h4>Woher weiss ich, wie die Farben
                    aussehen?</h4>

                <p>Angenommen Du möchtest Deinen Stoff an bereits vorliegende
                    Farben anpassen. Seien es z.B. Farben von Deinen
                    Standardbündchen oder Uni-Stoffen bei Dir Zuhause, eine
                    vorhandene Hose oder Taschen, die eine perfekte Kombifarbe
                    für Dein neue Nähprojekt erfordern.</p>

                <p>Dann bieten wir Dir eine
                    <InternalLink
                        to={{type: types.NAVIGATED_TO_COLORSWATCHES_CART_FORM}}
                        target="_blank"> Farbkarte
                        mit fertig bedruckten Farben +
                        Farbcode</InternalLink>. Diese Stofffarben gleichst Du
                    Zuhause mit vorliegenden Farben ab. Z.B. dem Grünton vom
                    neuen Rock für passenden Blusenstoff. Nimm entsprechenden
                    Farbcode von der Farbkarte und trage ihn ein. Dein
                    Stoffmuster färbt sich und wird in Deiner Wunschfarbe von
                    Deiner Farbkarte passgenau produziert.
                </p>

                <img
                    src="//d2k02hhj0n6fcf.cloudfront.net/images/colorswatch.jpg"
                    alt=""/>

                <h4>Wie stimme ich verschiedene
                    Stoffe aufeinander ab?</h4>

                <p>Achte auf die Farbcodes und nutze identische Farben in den
                    verschiedenen Stoffmustern. Damit bekommst Du immer farblich
                    identische Stoffe - alles aus einem Guss. Deine Farben. Dein
                    Stoff. Dein Unikat. Dein Designerstück.</p>

                <img
                    src="//d2k02hhj0n6fcf.cloudfront.net/images/colorcollection.jpg"
                    alt=""/>

                <h4>Ich sehe keine Kästchen mit Farbcode?</h4>
                <p>Manchmal hat ein Stoff-Motive einfach zu viele Farben um es
                    individuell einzufärben. Dann bleiben nur die
                    Schieberegler</p>

                <h3>2) Schieberegler für Farbvarianten</h3>

                <p>Benutze die Schieberegler um ein
                    Motiv harmonisch in einem
                    Farbton einzufärben.</p>

                <h4>Einfärben</h4>

                <p>Damit kannst Du ALLE Farben
                    gleichmäßig harmonisch ändern
                    und eine ureigene Farbwelt von
                    dem Muster gestalten.</p>

                <img
                    src="//d2k02hhj0n6fcf.cloudfront.net/images/colorize.png"
                    alt=""/>

                <h4>Sättigung</h4>

                <p>Wenn Du eher kräftige und sehr satte Farben liebst, wirst Du
                    merken, dass Dein Stoff mit dem Regler nach rechts immer
                    kräftigere Farben annimmt. Schiebst Du ihn nach links,
                    verliert er mehr und mehr von den Farben bis erschließelich
                    nur noch graue Töne hat.</p>

                <img
                    src="//d2k02hhj0n6fcf.cloudfront.net/images/saturation.png"
                    alt=""/>

                <h4>Helligkeit</h4>

                <p>Hier kannst Du den Kissen-Stoff auf
                    einer Skala von ganz schwarz
                    (Schieberegler ganz nach links)
                    bis komplett weiss
                    (Schiebereglern ganz nach
                    rechts) verändern.</p>

                <img src="//d2k02hhj0n6fcf.cloudfront.net/images/brightness.png"
                     alt=""/>

                <p>Du kannst Dir diese <Link
                    to="//d2k02hhj0n6fcf.cloudfront.net/images/Farben_FAQ.pdf">Anleitung
                    hier als PDF herunterladen</Link>.
                </p>
                <p>
                </p>
            </ContentWrapper>
        </article>
    );
};

export default ColoringOptions;



// WEBPACK FOOTER //
// ./src/components/de/faq-coloring-options.js